/*
 The way to make a change is triggering a new event on the window by:
 window.dispatchEvent(new CustomEvent('setBootstrapServiceURL',
  {bubbles: true, detail: {url: newUrl}}));
 Also can be unset with and empty or false value to take again the
 value from env.process
*/

export default (function () {
  const keyBootstrap = 'BSURL';
  return {
    getBootstrapURL: () => global.window.sessionStorage.getItem(keyBootstrap),
    setBootstrapURLHandler: (e) => {
      if (e.detail.url) {
        global.window.sessionStorage.setItem(keyBootstrap, e.detail.url);
      } else {
        global.window.sessionStorage.removeItem(keyBootstrap);
      }
    },
  };
});
